Auth = require 'db/auth'
l = require 'lib/localize'
MemberHomeView = undefined
queueRequire -> MemberHomeView = require 'views/member/member-home-view'
ModelCache = undefined
queueRequire -> ModelCache = require 'db/model-cache'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
Promise = require 'bluebird'
updateTimezone = require 'lib/update-timezone'
$ = require 'jquery'
Apdex = require('debug/apdex').default
log = require 'debug/log'
_ = require 'underscore'
assert = require 'lib/assert'
ApiError = require 'network/api-error'
getExperiment = require 'lib/experiments/simple-test'
trackGoogleTagManager = require 'debug/trackGoogleTagManager'
trackUe = require 'debug/trackUe'
viewLoaders = require './member-routes-view-loaders'
Util = require 'lib/util'
Storage = require 'lib/storage'
TrelloPerf = require('common/debug/perf').default
PerfKeys = TrelloPerf.Keys
Language = require 'lib/language'


# Variables used to determine if we should pretend the user is new, for testing
# purposes
simulateNewUser = null

# keeps track if the browser forward or back buttons are used
browserNav = false
$(window).on 'popstate', ->
  browserNav = true

# keeps track of whether we redirected on initial page load
isInitial = false

module.exports =
  routes: [
    ['', 'memberHomeView']
    [':orgname/home', 'memberHomeBoardsView']
    [':orgname/highlights', 'memberHomeView']
    [':username/boards', 'memberAllBoardsView']
    [':username/notifications', 'memberNotificationsView']
  ]

  displayMemberPage: (settings) ->
    { username, loadFn, viewClass, getLocation, bodyClass, product, orgname, titleKey, superHomeAllBoardsTab, superHomeCardsTabName, openNotifications } = settings
    username ?= Auth.myUsername()

    log('controller', ['memberHomeView'])

    Promise.using @getSpinner(), =>
      ModelLoader.release 'top-level'
      ModelLoader.for 'top-level', loadFn, username
      .then (member) =>
        memberHasNoBoards = member.boardList.length == 0 ||
          (member.boardList.length == 1 && member.boardList.models[0].isWelcomeBoard())

        simulateNewUser ?= $.cookie('simulateNewUser')

        isNewUser = simulateNewUser ||
          Util.idToDate(Auth.myId()) > Util.dateBefore({ days: 7 })

        if viewClass == MemberHomeView && isNewUser && memberHasNoBoards && !Auth.me().isDismissed('create-first-board')
          return @redirectToFirstBoard(member)

        @clearPreviousView()
        @setViewType(member)

        title =
          if Auth.isMe(member) && titleKey?
            l(['page title', titleKey])
          else
            "#{member.get('fullName')} (#{member.get('username')})"

        # Do this before creating the view, in case the view has more
        # specific logic for setting the URL
        @setLocation
          title: title
          location: getLocation.call(@, member.get('username'), product)
          options:
            replace: true

        options = { product, orgname, modelCache: ModelCache, superHomeAllBoardsTab, superHomeCardsTabName, openNotifications }

        memberView = @topLevelView(viewClass, member, options)
        @showHeader()
        @maybeShowFooterChrome(@getMemberBoardsUrl(member.get('username'), orgname, superHomeAllBoardsTab))

        if bodyClass
          $('#classic-body').addClass(bodyClass)
        else
          $('#classic-body').addClass('body-tabbed-page')

        $('#content').html(memberView.render().el)
        @focusContent()
        memberView.getData?()

        return
      .catch ApiError, =>
        @displayErrorPage()
        return

  redirectToFirstBoard: (member) ->
    isInInspirationExperiment = Language.is('en') && \
      getExperiment('onboarding').get('variation') == 'inlineInspirations'

    # There are two types of first boards to use: the default one we
    # auto-create for users, and madlibs. First step is to determine which
    # method to use.
    memberDoesNotBelongToTeams = member.organizationList.length == 0
    if memberDoesNotBelongToTeams && \
       getExperiment('onboarding').get('variation') != 'simplifiedView' && \
       !isInInspirationExperiment
      # this route is for madlibs
      return @navigate '/create-first-board', { trigger: true }

    # Data that we'll use in the body of the POST to create the default board
    initialData =
      name: l(['untitled board'])

    # Data that we're going to send in the create request; not all of the
    # fields will be board attributes
    requestData = _.extend({
      prefs_permissionLevel: 'private'
      prefs_selfJoin: true
      defaultLists: true
      creationMethod: 'automatic'
    }, initialData)

    newBoard = member.boardList.create initialData, {
      requestData: requestData
      success: (board) =>
        Auth.me().dismiss('create-first-board')
        # this fixes an issue with idBoards not being updated at the time that
        # the board gets rendered and the client thinking the member is not on
        # the board
        if board.id !in (currentBoards = Auth.me().get('idBoards'))
          Auth.me().set('idBoards', currentBoards.concat(board.id))

        # We have to wait until we get the board id back before we can
        # display the board
        @displayBoard({
          idBoard: board.id
          openListComposer: false
          openCardComposerInFirstList: !isInInspirationExperiment
          shouldShowInspirationPicker: isInInspirationExperiment
        }).done()

        return
      error: =>
        @displayErrorPage()
    }

    return

  memberAllBoardsView: (username) ->
    # caught by ':username/boards' route
    # but we actually want to show the 'memberHomeView'
    # just without any organisation, to show the SH all boards tab
    @memberHomeView(null, true)

  memberHomeBoardsView: (orgname) ->
    # Redirect early for non-existent orgs, before trying to load models
    ModelCache.waitFor 'Member', Auth.myId(), =>
      if !@isMemberOfOrg(orgname)
        return @redirectHomeToDefaultTab()

      # this is will show the org boards
      # adding these model loaders so we can show org boards that the user isn't a member of
      ModelLoader.release 'top-level'
      ModelLoader.for 'top-level', 'loadOrganizationBoardsData', orgname
        .then (org) =>
          @memberHomeView(orgname, true)

  memberHomeCardsView: (orgname, { pageName: cardsTabName }) ->
    if !cardsTabName
      url = @getMemberOrgUrl(orgname, null, 'due')
      return @navigate(url, { trigger: true, replace: true, shouldTrack: false })

    if !(cardsTabName == 'due' || cardsTabName == 'assigned')
      return @displayErrorPage()

    @memberHomeView(orgname, false, cardsTabName)

  memberHomeView: (orgname, superHomeAllBoardsTab, superHomeCardsTabName, openNotifications) ->
    if !Auth.isLoggedIn()
      # Hopefully you're not being routed here if you aren't logged in and
      # the server is sending you to the home page
      return @displayErrorPage()

    apdexTask = if superHomeAllBoardsTab then 'memberBoards' else 'memberHome'
    perfKey = if superHomeAllBoardsTab then PerfKeys.BOOTSTRAP_SUPERHOME_VIEW else PerfKeys.BOOTSTRAP_HOME_VIEW
    Apdex.start(task: apdexTask)
    TrelloPerf.startMeasurement(perfKey)

    ModelCache.waitFor 'Member', Auth.myId(), =>
      # neeed to check experiment here because if you check it before the user data isn't
      # loaded when you hit the cards url directly
      if superHomeCardsTabName && !getExperiment('superHomeTeamCards').get('enabled')
        Apdex.cancel(task: apdexTask)
        return @displayErrorPage()

      lastHomeTab = @getHomeLastTab()
      # if there is no orgname or it's not on all boards tab then it means we are on '/'
      # in that case if there is a last home tab that isn't '/' we want to redirect to that
      if !orgname && !superHomeAllBoardsTab && lastHomeTab && lastHomeTab != '/' && !browserNav
        browserNav = false

        # When a user lands on `/` and immediately gets redirected to `/:username/boards`,
        # we want to treat that as an "initialLoad" rather than a "transition" for Apdex
        # purposes. We need to explicitly tell the Apdex client this information, since
        # the URL change makes it look like we're doing a client-side transition even
        # though this the first rendered page the user is seeing.
        Apdex.cancel(task: apdexTask)
        isInitial = Apdex.isInitialLoad && Apdex.initialUrl == window.location.href

        return @navigate lastHomeTab, { trigger: true, replace: true, shouldTrack: false }
      else if browserNav
        # if navigating with browser nav buttons then we need to set the last tab
        Storage.set(@getHomeLastTabStorageKey(), window.location.pathname)

      if orgname && !@isMemberOfOrg(orgname)
        return @redirectHomeToDefaultTab()

      @trackMemberHomeView(orgname, superHomeAllBoardsTab)

      browserNav = false
      # If you're logged in, always kick you to your own boards page, since you
      # can't see anyone elses
      simulateNewUser ?= $.cookie('simulateNewUser')
      opts =
        username: 'me'
        loadFn: 'loadMemberBoardsData'
        viewClass: MemberHomeView
        getLocation: (username) =>
          @getMemberBoardsUrl(username, orgname, superHomeAllBoardsTab, superHomeCardsTabName)
        titleKey: 'boards'
        orgname: orgname
        superHomeAllBoardsTab: superHomeAllBoardsTab
        superHomeCardsTabName: superHomeCardsTabName
        openNotifications: openNotifications

      @displayMemberPage(opts)
        .then(updateTimezone)
        .then(=>
          title = if typeof orgname == 'undefined'
            l(['page title', 'home'])
          else if !orgname && superHomeAllBoardsTab
            l(['page title', 'boards'])
          else
            ModelCache.findOne('Organization', 'name', orgname)?.get('displayName')
          @title(title)
        )
        .tap ->
          if apdexTask != 'memberBoards' then return

          if isInitial then Apdex.resetInitialState()
          Apdex.stop(task: apdexTask)

          TrelloPerf.stopMeasurement(perfKey)
          TrelloPerf.reportStartupMetrics()

          isInitial = false
        .done()

      if( simulateNewUser || Util.idToDate(Auth.myId()) > Util.dateBefore({ minutes: 3 }))
        trackGoogleTagManager.possibleNewSignup()

  getHomeDefaultTab: ->
    @getMemberBoardsUrl(Auth.myUsername(), null, true, null)

  getHomeLastTabStorageKey: ->
    "home_#{Auth.myId()}_last_tab_2"

  getHomeLastTab: ->
    Storage.unset("home_#{Auth.myId()}_last_tab") # Clean up old key

    defaultTab = @getHomeDefaultTab()
    lastHomeTab = Storage.get(@getHomeLastTabStorageKey())

    if !lastHomeTab?
      return defaultTab

    if !(lastHomeTab == '/' || lastHomeTab.endsWith('/boards') || lastHomeTab.endsWith('/home'))
      # Clear out any invalid values
      Storage.unset(@getHomeLastTabStorageKey())
      return defaultTab

    return lastHomeTab

  redirectHomeToDefaultTab: ->
    Storage.unset(@getHomeLastTabStorageKey())
    @navigate(@getHomeDefaultTab(), { trigger: true, replace: true })

  isMemberOfOrg: (orgname) ->
    orgs = ModelCache.get('Member', Auth.myId())?.getSortedOrgs()
    return orgs.find((org) => org.get('name') == orgname)

  trackMemberHomeView: (orgname, superHomeAllBoardsTab) ->
    dirObj = ''
    context = {}

    if orgname && superHomeAllBoardsTab
      dirObj = 'team tab'
      context = {
        teamId: ModelCache.findOne('Organization', 'name', orgname)?.id
      }
    else if !orgname && superHomeAllBoardsTab
      dirObj = 'boards tab'
    else if !orgname && !superHomeAllBoardsTab
      dirObj = 'home tab'
    else
      return

    trackUe('home', 'loads', dirObj, '', '', '', context)

  memberNotificationsView: (username = 'me') ->
    # The member notifications view has been removed so
    # instead we redirect them to the homepage
    # with the notifications pane open
    return @memberHomeView(null, false, false, true)

  memberProfileView: (username = 'me') ->
    viewLoaders.memberProfile().then (MemberProfileView) =>
      @displayMemberPage
        username: username,
        loadFn: 'loadMemberProfileData'
        viewClass: MemberProfileView
        getLocation: @getMemberProfileUrl
        titleKey: 'profile'
      .done()

  memberCardsView: (username = 'me', { pageName: orgname }) ->
    viewLoaders.memberCards().then (MemberCardsView) =>
      @displayMemberPage
        username: username
        loadFn: 'loadMemberCardsData'
        viewClass: MemberCardsView
        getLocation: (username) =>
          @getMemberCardsUrl(username, orgname)
        titleKey: 'cards'
        orgname: orgname
      .done()

  memberAccountView: (username) ->
    username = 'me'
    viewLoaders.memberAccount().then (MemberAccountView) =>
      @displayMemberPage
        username: username
        loadFn: 'loadMemberAccountData'
        viewClass: MemberAccountView
        getLocation: @getMemberAccountUrl
        titleKey: 'settings'
      .done()

  memberBillingView: (username) ->
    username = 'me'
    viewLoaders.memberBilling().then (MemberBillingView) =>
      @displayMemberPage
        username: username
        loadFn: 'loadMemberBillingData'
        viewClass: MemberBillingView
        getLocation: @getMemberBillingUrl
        titleKey: 'billing'
      .done()



// WEBPACK FOOTER //
// ./app/scripts/controller/member-routes.coffee